import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import { overlayVisibleSelector } from '../../redux/ui/selectors';
import styles from './index.styl';

const Overlay = ({ visible }) => (
  <div
    styleName={classNames('root', {
      'root--visible': visible,
    })}
  />
);

Overlay.propTypes = {
  visible: PropTypes.bool,
};

Overlay.defaultProps = {
  visible: false,
};

export default connect(state => ({
  visible: overlayVisibleSelector(state),
}))(CSSModules(Overlay, styles, { allowMultiple: true }));



// WEBPACK FOOTER //
// ./src/components/Overlay/index.jsx